import 'whatwg-fetch';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setSupportedLanguages, injectIntl ,setChatEnabled} from '@s7ui-kit/s7ui-kit';
import isEmpty from 'lodash/isEmpty';

import SpecialOffers from '../components/common/new-mainpage/SpecialOffers';
import SmallBanners from '../components/common/new-mainpage/SmallBanners';
import ApplicationVerticalPlace from '../components/common/new-mainpage/ApplicationVerticalPlace';
import NewsBlock from '../components/common/new-mainpage/NewsBlock';
import OffersBlock from '../components/common/new-mainpage/OffersBlock';
import ShopBlock from '../components/common/new-mainpage/ShopBlock';
import PartnerBlock from '../components/common/new-mainpage/PartnerBlock/PartnerBlock';
import BlogBlock from '../components/common/new-mainpage/BlogBlock';
import MainSlider from '../components/main/MainSlider';
import DirectDirections from '../components/common/new-mainpage/DirectDirections';
import PromoBanner from '../components/common/new-mainpage/PromoBanner';
import NextFlight from '../components/main/next-flight/NextFlight';
import FAQBlock from "../components/common/new-mainpage/FAQBlock";
import RecommendationsCards from "../components/main/RecommendationsCards";

import { Bot } from '@s7ui-kit/portal-forms/build/bot';

import { loadSettings } from '../services/services/SettingsService';
import { s7PageInit } from "../services/utils/CDNPageInit";

import '@s7ui-kit/portal-forms/build/bot.css';

import '../assets/styles/components/sliderSlick.scss';
import '../assets/styles/pages/new-main-page.scss';

const mapStateToProps = ({App, User}) => ({App, User});

const mapDispatchToProps = dispatch => ({
    setSupportedLanguages: (languages = [ 'en', 'ru', 'zh', 'de', 'es', 'it' ]) => {
        return dispatch(setSupportedLanguages({languages}));
    },
    setChatEnabled: isChatEnabled => dispatch(setChatEnabled(isChatEnabled))
});

const NewMainPage = (props) => {
    const { App: {lang, currency, deviceWidth}, User: {profile, status} } = props;
    const { showHotelAviaTab } = props;
    const { words, getMessage } = props;

    const [ lastSearches, setLastSearches ] = useState([]);
    const [ trip, setTrip ] = useState({});
    const [ isS7TravelBotExpActive, setIsS7TravelBotExpActive ] = useState(!!s7PageInit?.isS7TravelBotExpActive );
    const [mainSettings, setMainSettings] = useState({
      // блок ближайшего рейса
      showNextFlight: false,
      // блок рекомендаций ближайшего рейса
      showNextFlightRecommendations: false,
      // блок спецпредложений
      showSpecialOffers: false,
      // блок маленьких баннеров
      showSmallBanners: false,
      // блок акций
      showOffersBlock: false,
      // блок промобаннера ( сейчас это Впечатления )
      showPromoBanner: false,
      // блок Shop
      showShopBlock: false,
      // блок рейсов
      showDirectFlights: false,
      // блок Предложения партнеров
      showPartnerOffers: false,
      // блок Новости
      showNewsBlock: false,
      // блок Блог
      showBlogBlock: false,
      // блок FAQ
      showFAQBlock: false,
    });

    useEffect(() => {
        props.setSupportedLanguages();
        if (s7PageInit && s7PageInit.settings && s7PageInit.settings.mainPage) {
          setMainSettings(s7PageInit.settings.mainPage);
        } else {
          loadSettings({ lang: lang, ns: "default" })
            .then((response) => {
              if (!response) {
                return;
              }
              setMainSettings(response.mainPage || {});
            })
            .catch((error) => console.log(error));
        }
    }, []);

    useEffect(() => {
        const onGuidyneLoaded = e => setIsS7TravelBotExpActive(!!e?.detail);

        window.addEventListener('guidyneLoaded', onGuidyneLoaded);
        return () => {
            window.removeEventListener('guidyneLoaded', onGuidyneLoaded);
        }
    }, []);

    useEffect(() => {
        if (deviceWidth < 768 && location && (!location.search || location.search && location.search.indexOf('open-chat') === -1)){
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if(entry?.boundingClientRect?.bottom > 0) props.setChatEnabled(entry?.isIntersecting);
                });
            });
            const holder = document.querySelector('.mainpage-holder');
            observer.observe(holder);
        }
    }, []);

    let flow = '';

    if (profile && profile.b2b && profile.b2b.b2b_flow) {
        flow = profile.b2b.b2b_flow;
    }

    if (profile && profile.b2b && profile.b2b.flow) {
        flow = profile.b2b.flow;
    }

    if (profile && profile.b2b_flow) {
        flow = profile.b2b_flow;
    }

    const getLastSearches = (elems) => {
        setLastSearches(elems);
    };

    const onStartBotInteraction = () => {
        s7PageInit.botInteractionStarted = true;
    };

    return (
        <div className={'mainpage'}>
            <div
                className="mainpage-slider-wrapper"
            >
                <MainSlider
                    lang={lang}
                    onNewMainPage={true}
                    lastSearches={lastSearches}
                />
            </div>
            <div className='mainpage-flight-bot'>
                {deviceWidth < 768 && mainSettings.showNextFlight &&
                    <div className={'mainpage-mobile-flight-holder'}>
                        <NextFlight
                            showTitle={true}
                            showRecomendations={false}
                            getTrip={trip => {
                                setTrip(trip);
                            }}
                        />
                    </div>}
                <div
                    className={'mainpage-bot'}
                    onClick={onStartBotInteraction}
                >
                    <Bot
                        lang={lang}
                        currencyType={currency}
                        isB2bVisible={!!(status && profile && profile.b2b)}
                        isTabNameForce={false}
                        tabName={'AVIA'}
                        flow={flow}
                        profile={profile}
                        openBooking={true}
                        openFieldsConsistently={true}
                        getLastSearches={getLastSearches}
                        showDirectRoutesCheckbox={true}
                        showHotelAviaTab={showHotelAviaTab}
                        isTravelTabActive={isS7TravelBotExpActive}
                    />
                </div>
            </div>
            <div className={'mainpage-holder'}>
                {deviceWidth < 768 && !isEmpty(trip) && lang === 'ru' && mainSettings.showNextFlightRecommendations &&
                <RecommendationsCards limit={3} trip={trip}/>}
                {deviceWidth >= 768 && mainSettings.showNextFlight && <NextFlight
                    showTitle={true}
                    showRecomendations={mainSettings.showNextFlightRecommendations}
                />}
                {mainSettings.showSpecialOffers && <SpecialOffers/>}
                {mainSettings.showSmallBanners && <div className={'mainpage-special-places'}>
                    <SmallBanners
                        deviceWidth={deviceWidth}
                        lang={lang}
                        profile={profile}
                    />
                    {deviceWidth >= 1024 && <ApplicationVerticalPlace />}
                </div>}

                {mainSettings.showOffersBlock && <div className={'mainpage__offers'}>
                    <OffersBlock />
                </div>}

                {lang === 'ru' && mainSettings.showPromoBanner && <div className={'mainpage__promo'}>
                    <PromoBanner
                        lang={lang}
                        title={getMessage(words, 'com.s7.main.page.promo.banner.title')}
                    />
                </div>}

                {mainSettings.showShopBlock && <div className={'mainpage__shop'}>
                    <ShopBlock />
                </div>}

                {mainSettings.showDirectFlights && <div className={'mainpage-direct-directions'}>
                    <DirectDirections/>
                </div>}

                {lang === 'ru' &&  mainSettings.showPartnerOffers && <PartnerBlock
                    lang={lang}
                />}

                {['ru', 'en'].includes(lang) && mainSettings.showNewsBlock && 
                <div className={'mainpage-news'}>
                    <NewsBlock/>
                </div>
                }

                {['ru', 'en'].includes(lang) && mainSettings.showBlogBlock && 
                <div className={'mainpage-blog'}>
                    <BlogBlock />
                </div>
                }
                {mainSettings.showFAQBlock && <div>
                    <FAQBlock/>
                </div>}
            </div>
        </div>
    );
};


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(React.memo(NewMainPage)));
